import httpClient from "../httpClient";

class LeadFormService {
    static submitForm({data}) {
      return httpClient.post("/lead_forms", data);
    }
}

export default LeadFormService;